<template>
  <div id="light-log" class="log-lights">
    
    <div class="panelheader border-2">
      <div class="title">{{pageName}}</div>
    </div>
    <div class="log_lights">
      <template>
        <vuetable
          ref="vuetable"
          api-url="/api/logs/lights"
          :http-options="header"
          :fields="columns"
          :per-page="10"
          pagination-path=""
          @vuetable:pagination-data="onPaginationData">
          <template slot="turned_on" slot-scope="props">
            <div v-if="props.rowData.turned_on == 'On'">
                <el-tag type="success">{{props.rowData.turned_on}}</el-tag>
            </div>
            <div v-else>
                <el-tag type="danger">{{props.rowData.turned_on}}</el-tag>
            </div>
           </template>
          </vuetable>
          <div class="vuetable-pagination ui basic segment grid">
            <vuetable-pagination-info ref="paginationInfo"
            ></vuetable-pagination-info>
               <vuetable-pagination 
                  ref="pagination"
                  @vuetable-pagination:change-page="onChangePage">

              </vuetable-pagination>
          </div>
      </template>
    </div>
  </div>
</template>

<script>
  import auth from '../../auth';
  export default {
    data(){
      return {
        pageName: 'Device Logs',
        header: {},
        columns: [
          {name: 'id', title: 'ID', titleClass: 'hidden', dataClass: 'hidden'},
          // {name: 'username', title: 'User', sortField: 'users.username'},
          {name: 'site_name', title: 'Site', sortField:'sites.name'},
          {name: 'field_name', title: 'Field', sortField: 'fields.field_name'},
          {name: 'action_time', title: 'Action Time', sortField: 'll.action_time'},
          {name: 'method', title: 'Source', sortField:'ll.method'},
          {name: '__slot:turned_on', title: 'On/Off', dataClass: 'center aligned', sortField:'ll.turned_on'},
        ]
      }
    },
    beforeMount() {
      var header = {headers: auth.getAuthHeader()};
      this.header = {headers:{'x-access-token':header['headers']['x-access-token']}};
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData);
        this.$refs.paginationInfo.setPaginationData(paginationData);
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      
    }
    
  }
</script>

<style>
  .log_lights {
    display: block;
    padding: 15pt;
    background-color: white;
  }

  .log_lights .ui.menu {
    font-size: 0.8rem;
  }

  .log-lights .ui.basic.segment {
    background-color: #F2F2F2;
  }
</style>


// WEBPACK FOOTER //
// LightsTable.vue?0d013072